module.exports = __webpack_public_path__ + "static/img/icon_partner_cnnc.c0e5417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_partner_cnnc.png
// module id = oJSo
// module chunks = 1